var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sopping_bag_button",
    "data-name": "Sopping bag button",
    transform: "translate(-327 -57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bag",
    transform: "translate(320.56 50.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    transform: "translate(6.44 6.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M22.334,11.107a.618.618,0,0,0-.619-.526H18.154V9.125a2.725,2.725,0,1,0-5.45,0V10.58H9.143a.618.618,0,0,0-.619.526L6.449,23.648a.609.609,0,0,0,.139.511.635.635,0,0,0,.48.217H23.805a.628.628,0,0,0,.635-.635.784.784,0,0,0-.031-.2ZM13.974,9.125a1.455,1.455,0,1,1,2.911,0V10.58H13.974V9.125Zm-6.162,14L9.685,11.85H12.7V15.4a.635.635,0,1,0,1.27,0V11.85h2.911V15.4a.635.635,0,1,0,1.27,0V11.85h3.019l1.873,11.271H7.812Z",
    transform: "translate(-6.44 -6.4)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    transform: "translate(341 71)",
    fill: "#fb6d3a",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 3.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_icon.0eb681a55983e0a5053d4956430b31f5.svg";
export { ForwardRef as ReactComponent };